import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { ApproveQService } from '../../services/approve-q.service';
import { EmailDetailService } from '../../services/email-detail.service';
import { SessionService } from '../../services/session2.service';
import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { GlobalMessageService } from '../../services/global-message.service';
import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';
import { Observable } from 'rxjs';
import { get } from 'lodash/object';
import { ConfigService } from 'app/services/config.service';

@Component({
  selector: 'bot-draft',
  templateUrl: './bot-draft.component.html',
  styleUrls: ['./bot-draft.component.scss']
})
export class BotDraftComponent implements OnInit {

  bCategories: any[] = [];
  showAdminDetail: boolean = false;

  @Input()
  botMeta: any = {};

  @Input()
  set botCategories(botCategories: any[]) {
    this.bCategories = botCategories;
    if (this.bCategories.length > 0) {
      this.botMeta.forEach(bm => {
        bm.categoryName = this.bCategories.find(bc => { return bc.id == bm.categoryId }).name;
      });
    }
  }

  @Output('onDelete')
  onDelete: EventEmitter<any> = new EventEmitter<any>();

  @Output('onApprove')
  onApprove: EventEmitter<any> = new EventEmitter<any>();

  @Output('onStopPending')
  onStopPending: EventEmitter<any> = new EventEmitter<any>();

  @Output('onCategoryChange')
  onCategoryChange: EventEmitter<any> = new EventEmitter<any>();

  @Output('onChangeToCustomer')
  onChangeToCustomer: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('deleteDialog')
  deleteDialog: TemplateRef<any>;

  @ViewChild('categoryDialog')
  categoryDialog: TemplateRef<any>;

  @ViewChild('ccDialog')
  ccDialog: TemplateRef<any>;

  selectedBotMeta: any;
  deleteDialogRef: BsModalRef;
  runUpdateTask: boolean = false;
  draftDeleted: boolean = false;
  customerReviewQueueToggle: boolean = false;
  session: any;

  categoryDialogRef: BsModalRef;
  selectedCategory: any = null;

  ccDialogRef: BsModalRef;
  addingCC: boolean = false;
  newCC: string = '';
  emailCampaign: any;

  mceOptions = {
    branding: false,
    height: 160,
    menubar: false,
    plugins: 'lists link',
    statusbar: false,
    toolbar: 'fontsizeselect bold italic bullist numlist link send change delete',
    setup: (editor) => {
      // editor.addButton('delete', {
      //   text: 'Delete Draft',
      //   icon: false,
      //   classes: 'sr sr-delete',
      //   onClick: (event) => {
      //     this.delete(event);
      //   }
      // });

      // editor.addButton('change', {
      //   text: 'Change Response',
      //   icon: false,
      //   classes: 'sr sr-delete',
      //   onClick: () => {
      //     this.change();
      //   }
      // });

      // editor.addButton('send', {
      //   text: 'Approve and Send',
      //   icon: false,
      //   classes: 'sr sr-send',
      //   onClick: () => {
      //     this.send();
      //   }
      // });
    }
  };

  emailCampaignsUrl: string = '';

  constructor(private modalService: BsModalService,
              private approveQService: ApproveQService,
              private globalMessageService: GlobalMessageService,
              private emailDetailService: EmailDetailService,
              private sessionService: SessionService,
              private cacheService: CacheService,
              private configService: ConfigService) {

    this.configService.driftAppUrl().subscribe((driftAppUrl: string) => {
      this.emailCampaignsUrl = `${driftAppUrl}/email/campaigns`;
    });
  }

  ngOnInit() {
    this.botMeta.forEach((bm) => {
      bm.matchProbability = bm.respondQItem ? bm.respondQItem.meta.p : bm.trackQItem.meta.p;
      bm.score = bm.respondQItem ? bm.respondQItem.meta.s : bm.trackQItem.meta.s;
      bm.exact = bm.respondQItem ? bm.respondQItem.meta.exact : bm.trackQItem.meta.exact;
      bm.fuzzy = bm.respondQItem ? bm.respondQItem.meta.fuzzy : bm.trackQItem.meta.fuzzy;
    });

    this.session = this.cacheService.get('session');

    if (!this.session) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.session = session;

          if (this.session.f) {
            this.customerReviewQueueToggle = this.session.f.customerReviewQueue || false;
          }
        }
      );
    } else {
      if (this.session.f) {
        this.customerReviewQueueToggle = this.session.f.customerReviewQueue || false;
      }
    }

    if (this.botMeta.playbook_id) {
      this.emailCampaign = this.emailDetailService.getCampaignDetails(this.botMeta.playbook_id);
    }
  }

  approve(bmItem: any) {
    this.selectedBotMeta = bmItem;
    let respondQId = this.selectedBotMeta.respondQItem ? this.selectedBotMeta.respondQItem._id : null;
    let trackQId = this.selectedBotMeta.trackQItem ? this.selectedBotMeta.trackQItem._id : null;

    let dlgMsg: string = `Please confirm you would like to approve the task(s) for this skill`;
    if (respondQId) {
      dlgMsg = `Please confirm you would like to approve task(s) and send this email`;
    }

    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: dlgMsg,
        confirm: function () {
          me.selectedBotMeta.respondQItem ? me.selectedBotMeta.respondQItem.meta.action = 'pending' : 0;
          me.selectedBotMeta.trackQItem ? me.selectedBotMeta.trackQItem.meta.action = 'pending' : 0;
          let template: string = me.selectedBotMeta.respondQItem ? me.selectedBotMeta.respondQItem.meta.email.html : null;
          let ccList = me.selectedBotMeta.respondQItem ? me.selectedBotMeta.respondQItem.meta.email.cc : null;
          let emailDetailId: string = me.selectedBotMeta.respondQItem ? me.selectedBotMeta.respondQItem.item_ids[0] : me.selectedBotMeta.trackQItem.item_ids[0];
          me.approveQService.approveDraft(respondQId, trackQId, template, ccList).subscribe(
            (result: any) => {
              me.onApprove.emit(me.selectedBotMeta);
            },
            error => {
              me.globalMessageService.error();
            }
          )
        }
      }
    }));
  }

  delete(bmItem: any) {
    this.selectedBotMeta = bmItem;
    this.deleteDialogRef = this.modalService.show(this.deleteDialog, { class: 'modal-md' });
  }

  deleteDraft() {
    const  respondQId = this.selectedBotMeta.respondQItem ? this.selectedBotMeta.respondQItem._id : null;
    const trackQId = this.selectedBotMeta.trackQItem ? this.selectedBotMeta.trackQItem._id : null;
    const emailDetailId: string = get(this, 'selectedBotMeta.respondQItem.item_ids[0]', get(this, 'selectedBotMeta.trackQItem.item_ids[0]'));
    this.approveQService.deleteDraft(emailDetailId, respondQId, trackQId, this.runUpdateTask).subscribe(
      () => {
        this.deleteDialogRef.hide();
        this.onDelete.emit(this.selectedBotMeta);
      },
      () => (void(0))
    );
  }

  editCC(bmItem: any) {
    this.selectedBotMeta = bmItem;
    this.ccDialogRef = this.modalService.show(this.ccDialog, { class: 'modal-lg' });
  }

  /**
   * Add an email address to the static list of email addresses for CCing
   */
  addCC() {
    // not a duplicate - add to list
    this.selectedBotMeta.respondQItem.meta.email.cc.push(this.newCC);

    // keep them sorted
    this.selectedBotMeta.respondQItem.meta.email.cc.sort((a: any, b: any) => {
      if (a.email_address < b.email_address) {
        return -1;
      }
      else {
        return 1;
      }
    });
    this.newCC = '';
    this.addingCC = false;
  }

  removeCC(recipient) {
    this.selectedBotMeta.respondQItem.meta.email.cc.splice(this.selectedBotMeta.respondQItem.meta.email.cc.findIndex(s => { return s.email_address == recipient; }), 1);
  }

  change(bmItem: any) {
    this.selectedBotMeta = bmItem;
    this.categoryDialogRef = this.modalService.show(this.categoryDialog, { class: 'modal-md' });
  }

  changeCategory() {
    this.categoryDialogRef.hide();
    // only emit if we actually changed the category
    if (this.selectedBotMeta.categoryId != this.selectedCategory) {
      this.onCategoryChange.emit({ bmItem: this.selectedBotMeta, categoryId: this.selectedCategory });
    }
  }

  stopPending(bmItem: any) {
    this.onStopPending.emit(bmItem);
  }

  pushToCustomer(bmItem: any) {
    this.selectedBotMeta = bmItem;
    const emailDetailId: string = this.selectedBotMeta.respondQItem ? this.selectedBotMeta.respondQItem.item_ids[0] : this.selectedBotMeta.trackQItem.item_ids[0];
    const respondApproveQId = get(this.selectedBotMeta.respondQItem, '_id', null);
    const trackApproveQId = get(this.selectedBotMeta.trackQItem, '_id', null);

    let sources = [];
    sources.push(this.emailDetailService.customerQueue(emailDetailId));
    if (respondApproveQId !== null) {
      sources.push(this.approveQService.customerQueue(respondApproveQId));
    }
    if (trackApproveQId !== null) {
      sources.push(this.approveQService.customerQueue(trackApproveQId));
    }

    Observable.forkJoin(...sources)
    .subscribe(
      () => {
        this.selectedBotMeta.action = 'customer';
        this.selectedBotMeta.respondQItem ? this.selectedBotMeta.respondQItem.meta.action = 'customer' : 0;
        this.selectedBotMeta.trackQItem ? this.selectedBotMeta.trackQItem.meta.action = 'customer': 0;
        this.onChangeToCustomer.emit(this.selectedBotMeta);
      },
      (error) => {
        throw error;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./client/app/inbox/bot-draft/bot-draft.component.ts